export const dataIntro = {
    title: 'Giới thiệu',
    title2: 'Giới thiệu',
    content: `Chăm sóc, bảo vệ và tô điểm mái ấm của những gia đình Việt Nam là mong muốn của Nippon Paint.

    Xu hướng kiến trúc nội thất hiện đại với bề mặt tường tông màu nhạt Off-Whites (OW) làm nổi bật cách bài trí nội thất theo sở thích, gu mỹ thuật và hoài niệm, đồng thời cũng tạo cảm giác nhẹ nhàng, thư giãn sau mỗi ngày làm việc.`,

    content2: `Chăm sóc, bảo vệ và tô điểm mái ấm của những gia đình Việt Nam là mong muốn của Nippon Paint.`,
    content3: `Xu hướng kiến trúc nội thất hiện đại với bề mặt tường tông màu nhạt Off-Whites (OW) làm nổi bật cách bài trí nội thất theo sở thích, gu mỹ thuật và hoài niệm, đồng thời cũng tạo cảm giác nhẹ nhàng, thư giãn sau mỗi ngày làm việc.`,
}

export const dataFunction = {
    title: 'tính năng',
    content1: 'Nippon Paint sử dụng nguyên liệu Acrylic Copolymer phối hợp cùng tinh màu cao cấp theo Công thức pha trộn với tỷ lệ được nghiên cứu chu đáo để tạo nên bề mặt bám dính tốt, phẳng mịn sau khi sơn và màu sắc nhẹ mát dịu, mang lại sự thư giãn, cảm giác tươi mới cho mọi thành viên gia đình.',
    content2: 'Với nhiều năm kinh nghiệm về khí hậu tại Việt Nam, Nippon Paint đặc biệt hiểu và ứng dụng phụ gia với Công nghệ Anti-Fungus Technology để tạo ra và duy trì khả năng chống lại vi khuẩn gây nấm mốc trên bề mặt sơn, giúp bảo vệ thẩm mỹ và an toàn sức khỏe cho các thành viên trong gia đình.',
    content3: 'Với các nguyên liệu thân thiện môi trường và an toàn sức khỏe cho người dùng, sản phẩm Matex Sắc Màu Dịu Mát có mùi nhẹ và không gây kích ứng cho các thành viên trong gia đình và ngay cả thợ sơn trong quá trình thi công.',
    content4: `Phát huy thế mạnh của dòng sản phẩm Matex so với các sản phẩm cùng cấp khác trên thị trường, Matex Sắc Màu Dịu Mát có độ che phủ tốt hơn, giúp cho bề mặt đẹp hơn, lợi ích kinh tế cao hơn.
   `,
   content4x: ` Đồng thời sản phẩm dễ thi công, dễ dặm vá trong quá trình thi công so với các sản phẩm tương đương khác.`,
    content5: `Với Công thức sản phẩm và Quy trình sản xuất được quản lý nghiêm ngặt, sản phẩm Matex Sắc Màu Dịu Mát ổn định mức Hàm lượng Chất Hữu Cơ Dễ Bay Hơi (VOC) ở mức dưới 25g/L và không chứa các kim loại nặng hay hóa chất ảnh hưởng đến sức khỏe người sử dụng.
    `,
    content6: `Theo tiêu chuẩn Singapore Green Label, sản phẩm này được xem là LowVOC và thân thiện môi trường.`
}

export const dataSystem = {
    title: 'Hệ thống sơn',
    title1: 'Hệ thống',
    title2:'sơn'
}

export const systemArray = [
    {
        step: 'Bột trét',
        content: '2-3 lớp',
    },
    {
        step: 'Sơn lót',
        content: '1 lớp',
    },
    {
        step: 'Sơn phủ',
        content: '2 lớp',
    }
]

export const linkData = `https://nipponpaint.com.vn/sites/default/files/2021-06/MATEX%20S%E1%BA%AEC%20M%C3%80U%20D%E1%BB%8AU%20M%C3%81T%20-%20SPEC%20-%20VNESE.pdf`


export const dataFlipingSytem = [
    {
        fe: 'Dụng cụ thi công',
        be: 'Dùng cọ quét, con lăn hoặc súng phun không có khí'
    },
    {
        fe: 'Thời gian khô',
        be: 'Khô bề mặt: 10 phút (nhiệt độ 30oC)'
    },
    {
        fe: 'Thời gian chuyển tiếp',
        be: 'Tối thiểu là 2 giờ ở điều kiện bình thường'
    },
    {
        fe: 'Độ dày màng sơn yêu cầu',
        be: 'Độ dày màng sơn khô là 30 – 40 micron cho một lớp sơn đối với điều kiện thi công bình thường.'
    },
    {
        fe: 'Mức tiêu hao',
        be: `Theo lý thuyết: 11.0 m2/ Lít 
        (Độ dày màng sơn khô 30 micron)`
    },
    {
        fe: 'Pha loãng',
        be: `Dùng nước sạch để pha loãng:`,
        be1:` - Phun không có khí: Tối đa 10%`,
        be2:` - Cọ quét và con lăn: Tối đa 20%`
    },
]

export const priceProduct = [
    {
        title: '5 lít',
        price: `400.000 VND*`
    },
    {
        title: '17 lít',
        price: `1.180.000 VND*`
    },
]